import { useCallback } from 'react'
import { Select } from 'antd'
import { switchLanguage, loadLanguage } from '../../Slices/LanguageSlice'
import { getTranslation } from '../../Services/StartupService'
import { Language_IT, Language_EN, Language_ES, Language_FR } from '../../Constants/Configuration'
import { handleErrorCatchLog } from '../../Helpers/GenericHelpers'
import { useAppDispatch, useAppSelector } from '../../hooks'

function LanguageDropdown() {
  const dispatch = useAppDispatch()
  const currentLang = useAppSelector(state => state.present.language.current)

  const onLanguageChange = useCallback(
    value => {
      dispatch(switchLanguage(value))
    },
    [dispatch],
  )

  const langOptions = [
    { label: Language_IT, value: Language_IT },
    { label: Language_EN, value: Language_EN },
    { label: Language_ES, value: Language_ES },
    { label: Language_FR, value: Language_FR },
  ]

  return (
    <Select
      value={currentLang}
      onChange={onLanguageChange}
      className='language-dropdown exclude-modal-click'
      variant={'borderless'}
      popupClassName='exclude-modal-click'
      options={langOptions}
    />
  )
}

export default LanguageDropdown
